import React from "react";
import { __ } from "services/Translator";

const OWN_AUTHORS = ["player", "visitor"];

export function isOwnMessage(authorType) {
  return OWN_AUTHORS.indexOf(authorType) !== -1;
}

export function authorLabel(message) {
  if (isOwnMessage(message.author_type)) {
    return __("You");
  }
  if (message.author_type === "bot") {
    return message.author_name || __("Assistant");
  }
  if (message.author_type === "system") {
    return __("System");
  }
  return message.author_name || __("Support");
}

function formatTime(value) {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

// Message bodies are rendered as TEXT, never as HTML. The column can hold
// markup (the backend keeps a stripped body_text alongside it for search), but
// nothing produces rich bodies yet and rendering them would mean trusting the
// sanitizer on every agent reply. HTML rendering lands with the agent console.
// Author is never signalled by colour alone: side, shape and a visible label
// all carry it.
export default function MessageBubble({ message }) {
  const own = isOwnMessage(message.author_type);
  const system = message.author_type === "system";
  const time = formatTime(message.created_at);

  return (
    <li className={"supMsg " + (system ? "isSystem" : own ? "isOwn" : "isAgent")}>
      <div className="supMsgMeta">
        <span className="supMsgAuthor">{authorLabel(message)}</span>
        {time && <span className="supMsgTime">{time}</span>}
      </div>
      <div className="supMsgBody">{message.body}</div>
      {message.delivery_status === "sending" && (
        <div className="supMsgPending">{__("Sending")}</div>
      )}
      {message.delivery_status === "failed" && (
        <div className="supMsgFailed">{__("Not delivered")}</div>
      )}
    </li>
  );
}
